import React, { CSSProperties } from 'react';
import { Location, matchPath, NavigateFunction, useLocation, useNavigate } from 'react-router';
import { Property } from 'csstype';
import { Col, Descriptions, Row, Tooltip } from 'antd';
import { PageHeader, PageHeaderProps } from '@ant-design/pro-components';
import parse from 'url-parse';
import { Link, Links, Page } from '../types/PageInfo';

import moment from 'moment-timezone';

import Request from '../model/Request';
//import { IPageHeaderProps } from 'ant-design-pro/es/PageHeader';
import AccreditationIcon from './icons/AccreditationIcon';
import DNSSECAccreditationIcon from './icons/DNSSECAccreditationIcon';

import { ButtonGroup, Item as ButtonGroupItem } from './Views/ButtonGroup';
//import {checkIsRegistry} from '../utils/token/TokenUtils.ts.old';
// import { rootAPI } from '../constants/globals';
import Pagination from 'antd/es/pagination/Pagination';
import Flex from './StyledComponents/Flex';
import StyledLink from './StyledComponents/StyledLink';
import { AppConf } from '../AppConf';
import Keycloak from 'keycloak-js';
import { isNullOrUndefined } from '../utils';
import { TFunction, useTranslation } from '@nic-react-i18n/core';
import { useKeycloak } from '@nic-react/auth';
import TestType from '../model/TestType';
import dayjs from 'dayjs';

type FlexDirectionProperty = Property.FlexDirection

interface PageHeaderWrapperInterface extends React.PropsWithChildren{
}

export const icons: Record<string, string> = {
    self: 'fal fa-sync',
    booking: 'fal fa-calendar',
    result: 'fal fa-tasks',
    request: 'fal fa-certificate',
    tests: 'fal fa-tasks',
    'action:book': 'fal fa-calendar-plus'
};

export const PageHeaderWrapper: React.FC<PageHeaderWrapperInterface & PageHeaderProps> = (props) => {
    return (
        <div>
            <PageHeader {...props}/>
            <div style={{marginTop: '10px'}}>
                {props.children}
            </div>
        </div>
    );

}

export const pushLink =
    (
        link: Link | null | undefined,
        action: string,
        token: Keycloak,
        navigate: NavigateFunction,
        from?: Location
    ) => {
        let location: Location;
        if (link && action !== 'action:book') {
            const {url:rootAPI} = AppConf.getRootUrl(token.realm ? token.realm : '');

            const other = 'other';
            const url = parse(link.href, true);
            const {pathname, query} = url;

            let elM = matchPath(`${rootAPI}/:other`, pathname);

            let realPathname: string = pathname;

            if (!isNullOrUndefined(elM)) {
                realPathname = '/' + elM?.params[other];
            }

            let queryString = '';
            if (query && Object.keys(query).length > 0) {
                queryString = '?';
                let keys =  Object.keys(query);
                for (let i = 0; i < keys.length - 1; i++) {
                    queryString += keys[i] + '=' + query[keys[i]] + '&';
                }
                queryString += keys[keys.length - 1] + '=' + query[keys[keys.length - 1]];
            }
            location = { pathname: realPathname, search: queryString} as Location;
        } else {
            let date = moment();
            location = from ?? {pathname: '', search: ''} as Location;
            location.pathname += '/calendar/month/' + date.format('YYYY') + '/' + date.format('MM');
        }
        navigate(location);
    };

const buildDescription = (registrar: string | undefined) => {
    return (
        <Descriptions title={<>''</>} size={'small'} column={2}>
            <Descriptions.Item label={'Registrar'}>
                {registrar?.toUpperCase() ?? ''}
            </Descriptions.Item>

        </Descriptions>
    );
};

interface RequestFilterStatusInterface {
    active: boolean;
    value?: string;
}
interface RequestFilterInterface {
    statusFilter: RequestFilterStatusInterface;
    typeFilter: RequestFilterStatusInterface;
}

const accreditationIcon = (size: string) => ({
    registrar: <AccreditationIcon color={'orange'} size={size}/>,
    dnssec: <DNSSECAccreditationIcon size={size}/>,
    undef: <span/>
});

const statusIcon = {
    succeeded: <span style={{paddingRight: '5px', color: 'green'}}><i className={'fal fa-thumbs-up'}/></span>,
    failed: <span style={{paddingRight: '5px', color: 'red'}}><i className={'fal fa-thumbs-down'}/></span>,
    pending: <span style={{paddingRight: '5px', color: 'orange'}}><i className={'fal fa-hourglass'}/></span>,
    undef: <span/>,
};

const rowStatusFilterComponent =
    (t: TFunction, filterMask: RequestFilterInterface, navigate: NavigateFunction, url: any) => {
        return(
            <ButtonGroup direction={'row'}>
                <ButtonGroupItem
                    style={{
                        borderRight: '1px solid #e9e9e9',
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.statusFilter.value === 'succeeded' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {status: 'succeeded'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);
                    }}
                >
                    {statusIcon.succeeded}
                    {t('requests.filter.succeeded')}
                </ButtonGroupItem>
                <ButtonGroupItem
                    style={{
                        borderRight: '1px solid #e9e9e9',
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.statusFilter.value === 'pending' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {status: 'pending'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);

                    }}
                >
                    {statusIcon.pending}
                    {t('requests.filter.pending')}
                </ButtonGroupItem>
                <ButtonGroupItem
                    style={{
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.statusFilter.value === 'failed' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {status: 'failed'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);

                    }}
                >
                    {statusIcon.failed}
                    {t('requests.filter.failed')}
                </ButtonGroupItem>
            </ButtonGroup>
        );
    };

const rowTypeFilterComponent =
    (t: TFunction, filterMask: RequestFilterInterface, navigate: NavigateFunction, url: any) => {
        return (
            <ButtonGroup direction={'row'}>
                <ButtonGroupItem
                    style={{
                        borderRight: '1px solid #e9e9e9',
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.typeFilter.value === 'registrar' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {type: 'registrar'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);
                    }}
                >
                    {accreditationIcon('1.2em').registrar}
                    {t('requests.filter.registrar')}
                </ButtonGroupItem>
                <ButtonGroupItem
                    style={{
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.typeFilter.value === 'dnssec' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {type: 'dnssec'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);
                    }}
                >
                    {accreditationIcon('1.2em').dnssec}
                    {t('requests.filter.dnssec')}
                </ButtonGroupItem>
            </ButtonGroup>
        );
    };

const columnStatusFilterComponent =
    (t: TFunction, filterMask: RequestFilterInterface, navigate: NavigateFunction, url: any) => {
        return (
            <ButtonGroup direction={'column'}>
                <ButtonGroupItem
                    style={{
                        borderBottom: '1px solid #e9e9e9',
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.statusFilter.value === 'succeeded' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {status: 'succeeded'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);
                    }}
                >
                    {statusIcon.succeeded}
                    {t('requests.filter.succeeded')}
                </ButtonGroupItem>
                <ButtonGroupItem
                    style={{
                        borderBottom: '1px solid #e9e9e9',
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.statusFilter.value === 'pending' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {status: 'pending'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);

                    }}
                >
                    {statusIcon.pending}
                    {t('requests.filter.pending')}
                </ButtonGroupItem>
                <ButtonGroupItem
                    style={{
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.statusFilter.value === 'failed' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {status: 'failed'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);

                    }}
                >
                    {statusIcon.failed}
                    {t('requests.filter.failed')}
                </ButtonGroupItem>
            </ButtonGroup>
        );
    };

const columnTypeFilterComponent =
    (t: TFunction, filterMask: RequestFilterInterface, navigate: NavigateFunction, url: any) => {
        return (
            <ButtonGroup direction={'column'}>
                <ButtonGroupItem
                    style={{
                        borderBottom: '1px solid #e9e9e9',
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.typeFilter.value === 'registrar' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {type: 'registrar'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);
                    }}
                >
                    {accreditationIcon('1.2em').registrar}
                    {t('requests.filter.registrar')}
                </ButtonGroupItem>
                <ButtonGroupItem
                    style={{
                        alignItems: 'center',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        backgroundColor:
                            (filterMask.typeFilter.value === 'dnssec' ? '#d9eafd' : 'transparent')
                    }}
                    onClick={() => {
                        let filter = {type: 'dnssec'};
                        url.query = {...url.query, ...filter};
                        let newUrl = parse(url.toString());
                        navigate(newUrl.pathname + newUrl.query);
                    }}
                >
                    {accreditationIcon('1.2em').dnssec}
                    {t('requests.filter.dnssec')}
                </ButtonGroupItem>
            </ButtonGroup>
        );
    };

const statusFilterByDirection: Record<string, any>  = {
    row: rowStatusFilterComponent,
    column: columnStatusFilterComponent
};

const typeFilterByDirection: Record<string, any> = {
    row: rowTypeFilterComponent,
    column: columnTypeFilterComponent
};

const filterHeader = (t: TFunction, direction: string, statusFilterComponent: any, typeFilterComponent: any) => {
    if (direction === 'row') {
        return (
            <Flex
                direction={'row'}
            >
                <div style={{paddingRight: '10px'}}>
                <span  style={{paddingRight: '10px', fontWeight: 800, color: 'orange'}}>
                    {t('requests.filters')}
                </span>
                </div>

                <div style={{paddingRight: '10px', borderRight: '1px solid #e9e9e9' , display: 'flex'}}>
                    <span  style={{paddingRight: '10px', fontWeight: 800, color: 'rgba(0, 0, 0, 0.43)'}}>
                        {t('requests.status.filter') + ': '}
                    </span>
                    {statusFilterComponent}
                </div>
                <Flex
                    direction={'row'}
                    style={{
                        paddingLeft: '10px',
                        paddingRight: '10px',
                    }}
                >
                    <span  style={{paddingRight: '10px', fontWeight: 800, color: 'rgba(0, 0, 0, 0.43)'}}>
                        {t('requests.type.filter') + ': '}
                    </span>
                    {typeFilterComponent}
                </Flex>
            </Flex>
        );
    } else {
        return (
            <div>
                <div style={{textAlign: 'center'}}>
                    <span  style={{paddingRight: '10px', fontWeight: 800, color: 'orange'}}>
                       {t('requests.filters')}
                    </span>
                </div>

                <span
                    style={{
                        paddingRight: '10px', fontWeight: 800, color: 'rgba(0, 0, 0, 0.43)',
                        paddingBottom: '5px'
                    }}
                >
                    {t('requests.status.filter') + ': '}
                </span>

                {statusFilterComponent}

                <span
                    style={{
                        paddingRight: '10px', fontWeight: 800, color: 'rgba(0, 0, 0, 0.43)',
                        paddingTop: '5px', paddingBottom: '5px'
                    }}
                >
                    {t('requests.type.filter') + ': '}
                </span>
                {typeFilterComponent}
            </div>
        );
    }
};

const requestsFilter =
    (t: TFunction, filterMask: RequestFilterInterface, location: Location, navigate: NavigateFunction, direction?: FlexDirectionProperty) => {

        let statusFilterComponent, typeFilterComponent;

        let url = parse(location.pathname + location.search, true);

        const nofilters: boolean =
            !filterMask.statusFilter.active && !filterMask.typeFilter.active;

        let realDirection = direction ?? 'column';

        statusFilterComponent = statusFilterByDirection[realDirection](t, filterMask, navigate, url);

        typeFilterComponent = typeFilterByDirection[realDirection](t, filterMask, navigate, url);

        return (
            <Flex
                direction={realDirection}
                wrap={'wrap'}
                style={{
                    width: (realDirection === 'row' ? 'auto' : '100%')
                }}
            >
                {filterHeader(t, realDirection, statusFilterComponent, typeFilterComponent)}
                {
                    !nofilters &&
                    <Flex
                        direction={'row'}
                        style={{
                            paddingLeft: (realDirection === 'row' ? '10px' : '0px'),
                            paddingTop: (realDirection === 'row' ? '0px' : '5px'),
                            paddingBottom: (realDirection === 'row' ? '0px' : '5px'),
                            paddingRight: (realDirection === 'row' ? '10px' : '0px') ,
                            borderLeft: (realDirection === 'row' ? '1px solid #e9e9e9' : 'none') ,
                        }}
                    >
                <span  style={{paddingRight: '10px', fontWeight: 800, color: 'rgba(0, 0, 0, 0.43)'}}>
                    {t('requests.reset.filter') + ': '}
                </span>

                        <StyledLink
                            cursor={'pointer'}
                            onClick={() => {
                                navigate('/requests');
                            }}
                        >
                            <i className={'fal fa-times-circle'}/>
                        </StyledLink>
                    </Flex>
                }

            </Flex>
        );
    };

const pushPage = (page: number, location: Location, navigate: NavigateFunction,  links: Links) => {


    let url = parse(location.pathname + location.search, true);
    let filter = {page: `${page - 1}`, size: '20'};
    url.query = {...url.query, ...filter};

    let newUrl = parse(url.toString());

    const path = newUrl.pathname + newUrl.query;
    navigate(path);
};

const Paginazione: React.FC<any> = (props) => {
    const location = useLocation()
    const navigate = useNavigate()
    const changePage = (page: number, pageSize: number) => {
        const { links} = props;

        pushPage(page, location,navigate, links);
    }

    const {pageInfo} = props;

    let url = parse(location.pathname + location.search, true);
    const pag = 'page';

    let currentPage: string | undefined = url.query[pag];
    let currPage: string = currentPage ?? '0';

    return (
        <Pagination
            onChange={changePage}
            total={pageInfo.totalElements}
            pageSize={20}
            simple={true}
            current={parseInt(currPage, 10) + 1}
            size={'small'}
        />
    );

}

export const calcFontSize = (width: number): {fontSize: number, iconSize: number} => {
    let res = {fontSize: 3, iconSize: 2};
    if (width <= 300) {
        res = {fontSize: 3, iconSize: 6};
    }

    if (width > 300 && width <= 600) {
        res = {fontSize: 3, iconSize: 6};
    }

    if (width > 600 && width <= 1000) {
        let multiply = 1000 / width;
        // console.log('multiply: ', multiply);
        res = {fontSize: 1.5 * multiply, iconSize: 2.5 * multiply};
    }

    if (width > 1000) {
        let multiply = 2000 / width;
        res = {fontSize: 0.7 * multiply, iconSize: 1.3 * multiply};
    }

    return res;
};

export const useBuildActionInfo =
    (pageInfo: Page,
     links: Links,
     direction?: FlexDirectionProperty) => {

        const {t} = useTranslation()
        const {keycloak} = useKeycloak()
        const location = useLocation()
        const navigate = useNavigate()

        //console.log('useBuildActionInfo: ', pageInfo, links, direction)


        // const leftSpace = {paddingLeft: '5px'};
        // const rightSpace = {paddingRight: '5px'};
        let url = parse(location.pathname + location.search, true);

        let isRegistryUser: boolean = (keycloak.realm === 'registry');

        const statusStatus: RequestFilterStatusInterface = {
            active: (!isNullOrUndefined(url.query.status)),
            value: url.query.status
        };

        const typeStatus: RequestFilterStatusInterface = {
            active: (!isNullOrUndefined(url.query.type)),
            value: url.query.type
        };

        const filterMask: RequestFilterInterface = {
            statusFilter: statusStatus,
            typeFilter: typeStatus
        };

        let realDirection: FlexDirectionProperty = ( direction ?? 'row');
        let paginationStyle: CSSProperties;

        if (realDirection === 'row') {
            paginationStyle = {display: 'flex', alignItems: 'center'};
        } else {
            paginationStyle = {display: 'flex', flexWrap: 'wrap'};
        }

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: realDirection,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    width: '100%'
                }}
            >

                {isRegistryUser && requestsFilter(t, filterMask, location, navigate, realDirection)}
                { links.last && links.first &&
                    <div style={paginationStyle}>
                    <span style={{paddingRight: '10px', fontWeight: 800, color: 'orange'}}>
                        {t('message.actions.page')}
                    </span>
                        <Paginazione pageInfo={pageInfo} links={links}/>
                    </div>
                }
            </div>
        );
    };

export const buildActiveLinks = (links: Record<string, any>, navigate: NavigateFunction, t: TFunction,
                                 token: Keycloak,
                                 location: Location, request?: Request): any => {
    let linksArray = [];
    if (links) {
        // let num = Object.keys(links).length;
        let i = 0;
        for (let link in links) {
            if (links.hasOwnProperty(link)) {
                const linkObj = links[link];
                const icon = icons[link];

                if (linkObj.show) {

                    const message = (! linkObj.enabled ? linkObj.message : `${link}.enabled`);
                    linksArray.push(
                        <div key={i++}>
                            <Tooltip
                                title={t(`${message}`)}
                            >
                                <StyledLink
                                    cursor={(linkObj.enabled ? 'pointer' : 'not-allowed')}
                                    style={
                                        {
                                            color: 'orange',
                                            paddingTop: '20px',
                                            paddingBottom: '20px',
                                            fontSize: '0.9rem',
                                            //  borderBottom: '1px dashed #dedede',
                                            // backgroundColor: '#dedede'
                                        }
                                    }
                                    onClick={() => {
                                        if (linkObj.enabled) {
                                            pushLink(links[link], link, token, navigate,  location);
                                        }
                                    }}
                                    title={linkObj.reasonMessage}
                                >
                                <span
                                    style={{
                                        paddingRight: '5px'
                                    }}
                                >
                                    <i className={`fal ${icon}`}/>
                                </span>
                                    <span>{t(`${link}`)}</span>
                                </StyledLink>
                            </Tooltip>
                        </div>
                    );
                }
            }
        }
        let description = null;

        if (request) {
            description = buildDescription(request.registrar);
        }

        return (
            <div>
                <Flex
                    direction={'row'}
                    justify={'flex-start'}
                >
                    {description}
                </Flex>

                <Flex
                    direction={'row'}
                    justify={'flex-start'}
                >
                    {linksArray}
                </Flex>
            </div>
        );
    }
};

export const buildContent = (links: Record<string, any>, navigate: NavigateFunction, t: TFunction,
                             token: Keycloak,
                             location: Location, request?: Request): any => {
    let linksArray = [];
    if (links) {
        let num = Object.keys(links).length;
        let i = 0;
        for (let link in links) {
            if (links.hasOwnProperty(link)) {
                linksArray.push(
                    <Col key={i++} lg={24 / num} >
                        <div
                            style={
                                {
                                    color: 'orange',
                                    cursor: 'pointer',
                                    paddingTop: '20px',
                                    paddingBottom: '20px',
                                    fontSize: '1.5vh',
                                    borderBottom: '1px dashed #dedede',
                                    // backgroundColor: '#dedede'
                                }
                            }
                            onClick={() => {
                                pushLink(links[link],  link, token, navigate, location);
                            }}
                        >
                                <span style={{border: '1px dashed orange', padding: '5px', borderRadius: '3px'}}>
                                    <i className={icons[link]}/> {t(`${link}`)}
                                </span>
                        </div>
                    </Col>
                );
            }
        }
    }
    let description = null;

    if (request) {
        description = buildDescription(request.registrar);
    }

    return (
        <Row>
            {description}
            {linksArray}
        </Row>
    );
};

export const buildExtraInfo = (pageInfo: Page) => {
    return (
        <Row>
            {pageInfo.totalPages > 1 &&
                <Col sm={24} md={12 / 4} lg={24 / 4}>
                    <div style={{color: 'rgba(0, 0, 0, 0.43)'}}>Pagina</div>
                    <div
                        style={{color: 'rgba(0, 0, 0, 0.85)', fontSize: 20}}
                    >
                        {pageInfo.totalElements > 0 ? pageInfo.number : '...'}
                    </div>
                </Col>
            }
            {pageInfo.totalPages > 1 &&
                <Col sm={24} md={12 / 4} lg={24 / 4}>
                    <div style={{color: 'rgba(0, 0, 0, 0.43)'}}>Elementi in Pagina</div>
                    <div
                        style={{color: 'rgba(0, 0, 0, 0.85)', fontSize: 20}}
                    >
                        {pageInfo.totalElements > 0 ? pageInfo.size : '...'}
                    </div>
                </Col>
            }
            {pageInfo.totalPages > 1 &&
                <Col sm={24} md={12 / 4} lg={24 / 4}>
                    <div style={{color: 'rgba(0, 0, 0, 0.43)'}}>Prenotazioni Totali</div>
                    <div
                        style={{color: 'rgba(0, 0, 0, 0.85)', fontSize: 20}}
                    >
                        {pageInfo.totalElements > 0 ? pageInfo.totalElements : '...'}
                    </div>
                </Col>
            }
            {pageInfo.totalPages === 1 &&
                <Col sm={24} md={24} lg={24}>
                    <div style={{color: 'rgba(0, 0, 0, 0.43)'}}>Prenotazioni Totali</div>
                    <div
                        style={{color: 'rgba(0, 0, 0, 0.85)', fontSize: 20}}
                    >
                        {pageInfo.totalElements > 0 ? pageInfo.totalElements : '...'}
                    </div>
                </Col>
            }
            {pageInfo.totalPages > 1 &&
                <Col sm={24} md={12 / 4} lg={24 / 4}>
                    <div style={{color: 'rgba(0, 0, 0, 0.43)'}}>Totale Pagine</div>
                    <div style={{color: 'rgba(0, 0, 0, 0.85)', fontSize: 20}}>{pageInfo.totalPages}</div>
                </Col>
            }
        </Row>
    );
};

export const dateAfterToday = (date: dayjs.Dayjs): boolean  => {
    const today = dayjs().format('YYYY-MM-DD');
    const formattedDate = date.format('YYYY-MM-DD');
    return (dayjs(formattedDate).isSame(dayjs(today)) || dayjs(formattedDate).isAfter(today));
};

const adjUrl = (url: string, sym: string, replace: string) => {
    return url.replace(sym, replace);
};

const fixUrl = (url: string) => {
    return adjUrl(url, ',', '');
};

const fixLinks = (links: any) => {
    const res: any = {};
    //console.log('FixLinks--> ', links);
    if (links !== undefined) {
        Object.keys(links).forEach((link: string) => {
            res[link] = {};
            res[link].href = fixUrl(links[link].href);
        });
    }
    //console.log('FixLinks ', res);
    return res;
};

export const fillRequest = (requestObj: Request, request: any) => {

    requestObj.created = request.created;
    requestObj.customerId = request.customerId;
    requestObj.ipAddress = request.ipAddress;
    requestObj.customerId = request.customerId;
    requestObj.maxTests = request.maxTests;
    requestObj.registrar = request.registrar;
    requestObj.contact = request.contact;
    requestObj.endDate = request.endDate;
    requestObj.created = request.created;
    requestObj.testType = {type: request.type, id: request.id, version: request.version} as TestType;
    requestObj.succededDate = request.succeededDate;
    requestObj.links = fixLinks(request._links);
    requestObj.id = request.id;
    requestObj.deleted = request.deleted;
    requestObj.status = (!isNullOrUndefined(request.status) ? request.status : 'pending');
};